import ApiClient from './ApiClient';

class BranchesAPI extends ApiClient {
  constructor() {
    super('branches', { accountScoped: true });
  }
}

export default new BranchesAPI();
